import './App.css';
import YouTubeVideoSection from './components/YouTubeVideoSection';
import OptimizedImage from './components/OptimizedImage';
import CodeitCertificates from './components/CodeitCertificates';
import CompactTimeline from './components/CompactTimeline';
// import BucketList from './components/BucketList';
import { useState, useEffect } from 'react';
import { SiReact, SiNodedotjs, SiMysql, SiStyledcomponents, SiAxios, SiRecoil, SiGmail, SiGithub, SiNextdotjs, SiTypescript, SiVercel, SiSupabase } from 'react-icons/si';
import { FaFigma, FaInstagram, FaYoutube } from 'react-icons/fa';
import { TbBrandOpenai } from 'react-icons/tb';
import { VscCode } from 'react-icons/vsc';

function Logo() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="logo" onClick={scrollToTop}>
      <img src="/img/cloverly.svg" alt="Cloverly" />
    </div>
  )
}

function App() {
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [guestMessage, setGuestMessage] = useState('');

  // 비디오 모달 닫기
  const closeVideoModal = () => {
    setShowVideoModal(false);
  };

  // 모바일 메뉴 토글
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  // 모바일 메뉴 닫기
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // 모바일 메뉴 열림/닫힘에 따른 body 스크롤 제어
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
      // ESC 키로 메뉴 닫기
      const handleEsc = (e) => {
        if (e.key === 'Escape') {
          closeMobileMenu();
        }
      };
      document.addEventListener('keydown', handleEsc);
      return () => {
        document.body.style.overflow = '';
        document.removeEventListener('keydown', handleEsc);
      };
    } else {
      document.body.style.overflow = '';
    }
  }, [mobileMenuOpen]);

  // 전체 사이트 우클릭 방지
  useEffect(() => {
    const preventContextMenu = (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    };

    const preventDrag = (e) => {
      if (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO') {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    const preventSelect = (e) => {
      try {
        // e.target이 텍스트 노드일 수 있으므로 Element인지 확인
        let target = e.target;
        // 텍스트 노드인 경우 부모 요소 사용
        if (target && target.nodeType === 3) {
          target = target.parentElement;
        }
        // Element이고 closest 메소드가 있는 경우에만 확인
        if (target && typeof target.closest === 'function') {
          const pdfContainer = target.closest('.protected-pdf-container');
          if (!pdfContainer) {
            e.preventDefault();
            window.getSelection()?.removeAllRanges();
            return false;
          }
        } else {
          // closest를 사용할 수 없는 경우에도 선택 방지
          e.preventDefault();
          window.getSelection()?.removeAllRanges();
          return false;
        }
      } catch (error) {
        // 오류 발생 시에도 선택 방지
        e.preventDefault();
        window.getSelection()?.removeAllRanges();
        return false;
      }
    };

    const preventKeyboard = (e) => {
      // PDF 영역은 제외
      try {
        const activeElement = document.activeElement;
        if (activeElement && typeof activeElement.closest === 'function') {
          const pdfContainer = activeElement.closest('.protected-pdf-container');
          if (!pdfContainer && (e.ctrlKey || e.metaKey) && (
            e.key === 's' || e.key === 'S' || 
            e.key === 'p' || e.key === 'P' ||
            e.key === 'i' || e.key === 'I' ||
            e.key === 'u' || e.key === 'U'
          )) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        } else if ((e.ctrlKey || e.metaKey) && (
          e.key === 's' || e.key === 'S' || 
          e.key === 'p' || e.key === 'P' ||
          e.key === 'i' || e.key === 'I' ||
          e.key === 'u' || e.key === 'U'
        )) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      } catch (error) {
        // 오류 발생 시에도 기본 동작 방지
        if ((e.ctrlKey || e.metaKey) && (
          e.key === 's' || e.key === 'S' || 
          e.key === 'p' || e.key === 'P' ||
          e.key === 'i' || e.key === 'I' ||
          e.key === 'u' || e.key === 'U'
        )) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }
    };

    // 이벤트 리스너 등록 (capture phase에서)
    document.addEventListener('contextmenu', preventContextMenu, true);
    document.addEventListener('dragstart', preventDrag, true);
    document.addEventListener('selectstart', preventSelect, true);
    document.addEventListener('keydown', preventKeyboard, true);

    return () => {
      document.removeEventListener('contextmenu', preventContextMenu, true);
      document.removeEventListener('dragstart', preventDrag, true);
      document.removeEventListener('selectstart', preventSelect, true);
      document.removeEventListener('keydown', preventKeyboard, true);
    };
  }, []);

  // 비디오 다운로드 방지
  useEffect(() => {
    const preventVideoDownload = (e) => {
      if (showVideoModal) {
        // 우클릭 방지
        if (e.button === 2 || e.which === 3) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }
    };

    const preventContextMenu = (e) => {
      if (showVideoModal) {
        try {
          let target = e.target;
          // 텍스트 노드인 경우 부모 요소 사용
          if (target && target.nodeType === 3) {
            target = target.parentElement;
          }
          if (target && typeof target.closest === 'function') {
            if (target.closest('.video-modal-container')) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          }
        } catch (error) {
          // 오류 발생 시에도 기본 동작 방지
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }
    };

    const preventKeyboard = (e) => {
      if (showVideoModal && (e.ctrlKey || e.metaKey) && (
        e.key === 's' || e.key === 'S'
      )) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    if (showVideoModal) {
      document.addEventListener('mousedown', preventVideoDownload, true);
      document.addEventListener('contextmenu', preventContextMenu, true);
      document.addEventListener('keydown', preventKeyboard, true);
      // ESC 키로 모달 닫기
      const handleEsc = (e) => {
        if (e.key === 'Escape') {
          closeVideoModal();
        }
      };
      document.addEventListener('keydown', handleEsc);

      return () => {
        document.removeEventListener('mousedown', preventVideoDownload, true);
        document.removeEventListener('contextmenu', preventContextMenu, true);
        document.removeEventListener('keydown', preventKeyboard, true);
        document.removeEventListener('keydown', handleEsc);
      };
    }
  }, [showVideoModal]);

  return (
    <div className="app">
      <header className="header">
        <Logo />
        <button 
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="메뉴 열기"
        >
          <span className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
        <nav className={`nav ${mobileMenuOpen ? 'nav-open' : ''}`}>
          <a href="#about" className="nav-link " onClick={closeMobileMenu}>소개</a>
          <a href="#work" className="nav-link" onClick={closeMobileMenu}>직업 활동</a>
          <a style={{fontWeight: 'bold'}} href="#recruitment" className="nav-link nav-link-divider-right" onClick={closeMobileMenu}>팀원 채용 제안</a>
          <a href="#music" className="nav-link" onClick={closeMobileMenu}>음악 활동</a>
          {/* <a style={{fontWeight: 'bold'}}href="#band" className="nav-link nav-link-divider-right" onClick={closeMobileMenu}>밴드 팀원 제안</a> */}
          <a href="#exercise" className="nav-link" onClick={closeMobileMenu}>운동 활동</a>
          <a href="#travel" className="nav-link nav-link-divider-right" onClick={closeMobileMenu}>여행 활동</a>
          {/* <a href="#bucketlist" className="nav-link nav-link-divider-right" onClick={closeMobileMenu}>버킷리스트</a> */}
          <a style={{fontWeight: 'bold'}} href="#guestbook" className="nav-link" onClick={closeMobileMenu}>인연 방명록</a>
        </nav>
        {mobileMenuOpen && (
          <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
        )}
      </header>

      <main className="main">
        {/* Hero Section */}
        <section className="hero">
          <div className="hero-background">
            <div className="hero-background-overlay"></div>
            <div className="hero-background-pattern"></div>
          </div>
          <div className="hero-content">
            {/* <div className="hero-badge">
              <span className="badge-text">소소한 일상의 행복</span>
            </div> */}
            <h1 className="hero-title">
              <span className="title-main">Cloverly</span>
              <span className="title-subtitle">클로버리</span>
            </h1>
            <p className="hero-slogan">
              좋아하는걸 하며, 느긋하고 즐겁게 살아요.<br />
              그러다 좋은 일이 생기면, 행운이죠 <span className="clover-emoji">🍀</span>
            </p>
          
            <div className="hero-scroll-indicator">
              <div className="scroll-line"></div>
              <span className="scroll-text">Scroll</span>
            </div>
          </div>
          <div className="hero-nature-elements">
            <div className="nature-leaf leaf-1">🌿</div>
            <div className="nature-leaf leaf-2">🍃</div>
            <div className="nature-leaf leaf-3">🌱</div>
            <div className="nature-clover">🍀</div>
          </div>
        </section>

        {/* About Section */}
        <section className="about" id="about">
          <div className="section-content">
            <h2 className="section-title">소개</h2>
            <div className="about-brand">
              <h3 className="brand-name">Cloverly<span className="brand-korean"><br/>(클로버리)</span></h3>
              <p className="brand-tagline">"Clover + Lovely"</p>
              <div className="brand-symbol">
                <img src="/img/cloverly_symbol.svg" alt="Cloverly Symbol" />
              </div>
            </div>
            <p className="section-text about-intro">
              클로버리는 행복, 행운의 심볼인 클로버와<br />사랑의 마음을 담은 디온의 포트폴리오 브랜드입니다.<br /><br />
   평범하고, 여유로운 일상 속에서<br/>소소한 행복을 함께 즐기고 싶네요 ✨
            </p>
          </div>
        </section>

        {/* Developer Activity Section */}
        <section className="developer-activity" id="work">
          <div className="section-content">
            <h2 className="section-title">직업 활동</h2>
            
            {/* 노마드 개발자 프로필 */}
            <div className="profile-card" style={{marginBottom: '4rem', maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto'}}>
                <div className="profile-image-circle">
                  <OptimizedImage src="/img/11.WEBP" alt="노마드 개발자" className="profile-img" priority={true} />
                </div>
              {/* <h3 className="profile-role">기획자 / 개발자 / 마케터</h3>
              <div className="github-link" style={{marginTop: '0.2rem'}}>
                <SiGithub className="github-icon" />
                <a 
                  href="https://github.com/yolodion" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="github-username"
                >
                  yolodion
                </a>
              </div> */}
                </div>
            
            {/* 외주 출시 서비스 */}
            <div className="outsource-service">
              <div className="subsection-header">
                <h3 className="subsection-title">스타트업 출시 서비스 ✨</h3>
              </div>
              <div className="outsource-card">
                <div className="project-type-tag project-type-team">스타트업 팀 프로젝트</div>
                <div className="status-bar">
                  <span className="status-badge status-operating">운영중</span>
                  <span className="status-badge status-role">디온 - COO/PM 역할 수행</span>
                  <span className="status-badge status-launch">앱 출시 완료</span>
                </div>
                <div className="outsource-logo">
                  <OptimizedImage src="/img/wally.png" alt="wally" className="wally-logo-img" />
                </div>
                <p className="outsource-description">윌리(반려동물 돌봄 이웃)</p>
                <div className="wally-download-buttons">
                  <a 
                    href="https://play.google.com/store/apps/details?id=com.flynnapps.wally" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn-download"
                  >
                    안드로이드 다운
                  </a>
                  <a 
                    href="https://apps.apple.com/kr/app/%EC%9B%94%EB%A6%AC-%ED%8E%AB%EC%8B%9C%ED%84%B0-%EB%A7%9E%EC%B6%A4-%EB%8F%8C%EB%B4%84-%EC%84%9C%EB%B9%84%EC%8A%A4/id6741297868" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn-download"
                  >
                    IOS 다운
                  </a>
                </div>
              </div>
            </div>

            {/* 포트폴리오 (기획 + 개발) */}
            <div className="portfolio-section">
              <div className="subsection-header">
                <h3 className="subsection-title">포트폴리오<span className="title-sparkle">✨</span></h3>
                <div className="portfolio-notice">
                  <p className="portfolio-notice-text">
                    기획 포트폴리오는 외부 공개가 어려워 홈페이지에는 업로드하지 않았습니다. 다만 오프라인 미팅 시 요청해 주시면, 공유 가능한 범위 내에서 일부만 간단히 보여드릴 순 있습니다.
                  </p>
                </div>
              </div>
              <div className="portfolio-grid">
                <div className="portfolio-card">
                  <div className="project-type-tag">개인 프로젝트</div>
                  <div className="portfolio-logo">
                    <OptimizedImage src="/img/chianfluencer.png" alt="체인플루언서" className="portfolio-logo-img" />
                  </div>
                  <h4 className="portfolio-name">체인플루언서</h4>
                  <p className="portfolio-description">(블록체인 커뮤니티)</p>
                  <div className="portfolio-status status-launched">출시 완료 / 운영 종료</div>
                  
                  {/* 체인플루언서 이미지 */}
                  <div className="chainfluencer-image">
                    <div className="chainfluencer-image-wrapper">
                      <OptimizedImage src="/img/체인플루언서.png" alt="체인플루언서 서비스 이미지" />
                    </div>
                    <div className="chainfluencer-image-wrapper" style={{marginTop: '1rem'}}>
                      <OptimizedImage src="/img/체인플루언서1.png" alt="체인플루언서 서비스 이미지 2" />
                    </div>
                  </div>
                </div>
                <div className="portfolio-card">
                  <div className="project-type-tag">개인 프로젝트</div>
                  <div className="portfolio-logo">
                    <OptimizedImage src="/img/tripic.png" alt="트리픽" className="portfolio-logo-img" />
                  </div>
                  <h4 className="portfolio-name">트리픽</h4>
                  <p className="portfolio-description">(취향별 여행지 추천 SNS)</p>
                  <div className="portfolio-status status-launched tripic-status">출시 완료 / 운영 종료</div>
                  
                  {/* 트리픽 스크린샷 갤러리 */}
                  <div className="tripic-screenshots">
                    <button 
                      className="btn-portfolio-purchase btn-over-screenshots"
                      onClick={() => window.open('https://kmong.com/gig/426892', '_blank', 'noopener,noreferrer')}
                    >
                      서비스 구매하기
                    </button>
                    <div className="screenshot-grid">
                      <div className="screenshot-item">
                        <OptimizedImage src="/img/트리픽1.jpeg" alt="트리픽 스크린샷 1" />
                      </div>
                      <div className="screenshot-item">
                        <OptimizedImage src="/img/트리픽2.jpeg" alt="트리픽 스크린샷 2" />
                      </div>
                      <div className="screenshot-item">
                        <OptimizedImage src="/img/트리픽3.jpeg" alt="트리픽 스크린샷 3" />
                      </div>
                      <div className="screenshot-item">
                        <OptimizedImage src="/img/트리픽4.jpeg" alt="트리픽 스크린샷 4" />
                      </div>
                      <div className="screenshot-item">
                        <OptimizedImage src="/img/트리픽5.jpeg" alt="트리픽 스크린샷 5" />
                      </div>
                      <div className="screenshot-item">
                        <OptimizedImage src="/img/트리픽6.jpeg" alt="트리픽 스크린샷 6" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="portfolio-card">
                  <div className="project-type-tag">개인 프로젝트</div>
                  <div className="portfolio-logo">
                    <OptimizedImage src="/img/myshareroutine.png" alt="마이쉐어루틴" className="portfolio-logo-img" />
                  </div>
                  <h4 className="portfolio-name">마이쉐어루틴</h4>
                  <p className="portfolio-description">(루틴 영상 공유 + 친구 매칭 SNS)</p>
                  <div className="portfolio-status status-completed">개발 완료</div>
                </div>
                <div className="portfolio-card">
                  <div className="project-type-tag">개인 프로젝트</div>
                  <div className="portfolio-logo">
                    <OptimizedImage src="/img/hiddenmarket.png" alt="히든마켓" className="portfolio-logo-img" />
                  </div>
                  <h4 className="portfolio-name">히든마켓</h4>
                  <p className="portfolio-description">물물교환 재테크 + 나눔 플랫폼</p>
                  <div className="portfolio-status status-completed">개발 완료</div>
                </div>
              </div>
            </div>
            
            {/* 디온 아이디어 서비스 섹션 */}
            <div className="portfolio-section">
              <div className="subsection-header">
                <h3 className="subsection-title">디온 아이디어 서비스<span className="title-sparkle">✨</span></h3>
              </div>
              <div className="services-grid">
                <div className="service-card">
                  <div className="service-category category-dating">연애</div>
                  <div className="service-logo">
                    <OptimizedImage src="/img/meetu.png" alt="밋유" className="service-logo-img" />
                  </div>
                  <h3 className="service-name">밋유</h3>
                  <p className="service-description">
                    "너라는 우주를 만나다"<br />
                    (궁금증 유발 감성 가치관 소개팅)
                  </p>
                  <div className="service-status status-completed">개발 완료 / 운영 가능</div>
                </div>
                <div className="service-card">
                  <div className="service-category category-travel">여행</div>
                  <div className="service-logo">
                    <OptimizedImage src="/img/momentrip_logo.png" alt="모멘트립" className="service-logo-img" />
                  </div>
                  <h3 className="service-name">모멘트립</h3>
                  <p className="service-description">
                    "순간을 여행처럼"<br />
                    (인생샷 및 추억 공유 여행 플랫폼)
                  </p>
                       <div className="service-status status-completed">개발 완료 / 운영중</div>
                </div>
                <div className="service-card">
                  <div className="service-category category-entertainment">연예</div>
                  <div className="service-logo">
                    <div className="service-icon-large">?</div>
                  </div>
                  <h3 className="service-name">꿈트리</h3>
                  <p className="service-description">
                    "오늘도 한걸음씩 나아가는 너의 꿈을 응원할게"<br />
                    (꿈 응원·후원·멘토링·팬덤 SNS)
                  </p>
                  <div className="service-status status-idea">아이디어 단계</div>
                </div>
                <div className="service-card">
                  <div className="service-category category-music">음악</div>
                  <div className="service-logo">
                    <div className="service-icon-large">?</div>
                  </div>
                  <h3 className="service-name">버스커</h3>
                  <p className="service-description">
                    "너가 있는 어디든 함께하는 즐거운 무대가 될 수 있어"<br />
                    (누구나 비긴어게인이 될 수 있는 음악 소셜 버스킹 서비스)
                  </p>
                  <div className="service-status status-idea">아이디어 단계</div>
                </div>
              </div>
              {/* <button className="btn-continued">To Be Continued!</button> */}

   <div className="subsection-header">
                <h3 className="subsection-title">Cloverly Shop<span className="title-sparkle">✨</span></h3>
              </div>
              <div className="mvp-shop-showcase">
                <div className="mvp-shop-content">
                  <div className="mvp-shop-badge">구매 가능한 MVP 서비스</div>
                  <h4 className="mvp-shop-title">바로 서비스를 둘러보고 구매할 수 있어요!</h4>
                  <p className="mvp-shop-description">
                    디온이 기획하고 제작한 MVP 서비스들을 한 곳에서 확인할 수 있는 공간입니다.<br />
                    감성적인 무드와 함께 실제 구매 가능한 서비스 중심으로 정리해두었습니다.
                  </p>
                  <div className="mvp-shop-points">
                    <span className="mvp-shop-point">실제 구매 가능</span>
                    <span className="mvp-shop-point">기획 + 개발 기반</span>
                    <span className="mvp-shop-point">감성 기반 UX/UI</span>
                  </div>
                </div>
                <div className="mvp-shop-actions">
      
                  <a
                    href="https://cloverly-shop.vercel.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-mvp-shop"
                  >
                    MVP 서비스 보러가기
                    <span className="mvp-shop-arrow">↗</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Team Recruitment Section */}
        <section className="team-recruitment" id="recruitment">
          <div className="section-content">
            <div className="subsection-header">
              <h3 className="subsection-title">팀원 채용 제안<span className="title-sparkle">✨</span></h3>
            </div>
            <div className="recruitment-container">
              <div className="recruitment-left">
                <div className="recruitment-photo">
                  <OptimizedImage src="/img/7.png" alt="김동현" className="recruitment-img" priority={true} />
                </div>
                <div className="recruitment-name">
                  <h4 className="name-kr">김동현(디온, 만 30세)</h4>
                  <p className="name-role">Frontend Developer</p>
                  <div className="github-link">
                    <SiGithub className="github-icon" />
                    <a 
                      href="https://github.com/yolodion"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="github-username"
                    >
                      yolodion
                    </a>
                  </div>
                  <div className="github-description">
                    <p className="github-description-text">
                    깃허브에는 토이 프로젝트를 제외한 대부분의 코드는 회사 및 상업적 가치 보호를 위해 Private로 설정하여 공개하기 어렵습니다. 다만, 오프라인 미팅 시 요청하시면 가능한 범위 내에서 간단히 보여드릴 순 있습니다.                    </p>
                  </div>
                  {/* <div className="developer-mindset">
                    <div className="developer-mindset-icon">💡</div>
                    <p className="developer-mindset-text">
                      부트캠프 수료 후, 풀스택으로 여러 서비스를 개발한 경험이 있지만, 최근 몇 년간은 기획 업무를 하면서 개발 감이 조금 떨어진 상태입니다. 하지만 개발적인 추론 & 논리력이나 기획 보완은 충분히 자신있습니다. 지금은 주니어 프론트엔드 개발자의 마음가짐으로, 협업하며 배우고 기반을 다져 나가고 싶습니다. 그렇게 함께 즐겁게 일할 수 있는 팀을 정말 만나고 싶네요 😊
                    </p>
                  </div> */}
                </div>
              </div>
              <div className="recruitment-right">
                <div className="recruitment-section">
                  <h5 className="recruitment-section-title">[학력]</h5>
                  <div className="education-main-box">
                    <span className="education-main-title">국립 부경대학교, 제어계측공학과 전공</span>
                  </div>
                </div>
                <div className="recruitment-section">
                  <h5 className="recruitment-section-title">[경력]</h5>
                  <div className="career-main-box">
                    <span className="career-main-title">IT 8년차 기획자 / 개발자</span>
                  </div>
                  <div className="compact-timeline-section">
                    <CompactTimeline />
                  </div>
                </div>
                <div className="recruitment-section">
                  <h5 className="recruitment-section-title">[희망 조건]</h5>
                  <ul className="recruitment-list">
                    <li>참여 직책(팀원):프론트 개발자 or 콘텐츠 마케터</li>
                    <li>근무 시간: 오후 1시 ~ 5시</li>
                    <li>근무 환경: 원격 근무 및 사무실 출근(마산·창원·부산·제주)</li>
                    <li>월급: 협의 가능(직전 연봉 6,000만원)</li>
                    {/* <li>주 4일 근무제 희망(금요일 휴무, 협의 가능)</li> */}
                  </ul>
                  <div className="recruitment-principles">
                    <div className="recruitment-principle-card">
                      <span className="principle-icon">👑</span>
                      <span className="principle-text">모든 책임과 팀원 관리 및 의사 결정은 대표님의 몫</span>
                    </div>
                    <div className="recruitment-principle-card">
                      <span className="principle-icon">💪</span>
                      <span className="principle-text">일에 최선을 다하는 것은 팀원의 몫</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* 기술 스택 섹션 */}
            <div className="tech-stack-section">
              <h5 className="tech-stack-title">🛠️ 개발자 기술 스택</h5>
              <div className="tech-stack-grid">
                <div className="tech-stack-item">
                  <div className="tech-stack-icon react-icon">
                    <SiReact />
                  </div>
                  <div className="tech-stack-name">React</div>
                </div>
                <div className="tech-stack-item">
                  <div className="tech-stack-icon nodejs-icon">
                    <SiNodedotjs />
                  </div>
                  <div className="tech-stack-name">Node.js<br />(Express)</div>
                </div>
                <div className="tech-stack-item">
                  <div className="tech-stack-icon mysql-icon">
                    <SiMysql />
                  </div>
                  <div className="tech-stack-name">MySQL</div>
                </div>
                <div className="tech-stack-item">
                  <div className="tech-stack-icon styled-components-icon">
                    <SiStyledcomponents />
                  </div>
                  <div className="tech-stack-name">Styled-components</div>
                </div>
                <div className="tech-stack-item">
                  <div className="tech-stack-icon recoil-icon">
                    <SiRecoil />
                  </div>
                  <div className="tech-stack-name">Recoil</div>
                </div>
                <div className="tech-stack-item">
                  <div className="tech-stack-icon axios-icon">
                    <SiAxios />
                  </div>
                  <div className="tech-stack-name">Axios</div>
                </div>
                <div className="tech-stack-item">
                  <div className="tech-stack-icon chatgpt-icon">
                    <TbBrandOpenai />
                  </div>
                  <div className="tech-stack-name">ChatGPT</div>
                </div>
                <div className="tech-stack-item">
                  <div className="tech-stack-icon cursor-icon">
                    <VscCode />
                  </div>
                  <div className="tech-stack-name">Cursor</div>
                </div>
                <div className="tech-stack-item">
                  <div className="tech-stack-icon figma-icon">
                    <FaFigma />
                  </div>
                  <div className="tech-stack-name">Figma</div>
                </div>
                <div className="tech-stack-item">
                  <div className="tech-stack-icon nextjs-icon">
                    <SiNextdotjs />
                  </div>
                  <div className="tech-stack-name">Next.js</div>
                </div>
                <div className="tech-stack-item">
                  <div className="tech-stack-icon typescript-icon">
                    <SiTypescript />
                  </div>
                  <div className="tech-stack-name">TypeScript</div>
                </div>
                <div className="tech-stack-item">
                  <div className="tech-stack-icon vercel-icon">
                    <SiVercel />
                  </div>
                  <div className="tech-stack-name">Vercel</div>
                </div>
                <div className="tech-stack-item">
                  <div className="tech-stack-icon supabase-icon">
                    <SiSupabase />
                  </div>
                  <div className="tech-stack-name">Supabase</div>
                </div>
                <div className="tech-stack-item tech-stack-more">
                  <div className="tech-stack-icon more-icon">
                    <span className="more-dots">...</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* 코드잇 수료증 섹션 */}
            <div className="codeit-certificates-section">
              <h5 className="codeit-certificates-title">📚 코드잇 수료증</h5>
              <CodeitCertificates />
            </div>
            
            {/* 성과물 섹션 */}
            <div className="achievements-section">
              <h5 className="achievements-title">✨ 주요 성과</h5>
              <div className="achievements-grid">
                <div className="achievement-card achievement-card-essay">
                  <div className="achievement-image-wrapper">
                    <OptimizedImage src="/에세이.png" alt="넌 언제든 시작할 수 있어 에세이" className="achievement-image" />
                  </div>
                  <div className="achievement-label">에세이 출간</div>
                  <div className="achievement-name">'넌 언제든, 시작할 수 있어'</div>
                  <a 
                    href="https://search.shopping.naver.com/book/catalog/38341651618?cat_id=50011280&frm=PBOKPRO&query=%EB%94%94%EC%98%A8+%EB%84%8C+%EC%96%B8%EC%A0%9C%EB%93%A0+%EC%8B%9C%EC%9E%91%ED%95%A0+%EC%88%98+%EC%9E%88%EC%96%B4&NaPm=ct%3Dmi67h5nc%7Cci%3Ddf52bfe883a36f8333cf492bac34fbf2d989b801%7Ctr%3Dboknx%7Csn%3D95694%7Chk%3D6b6ce7e84ea629e23d043807a6aa146754af8607"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-essay-purchase"
                  >
                    에세이 구매하기
                  </a>
                </div>
                <div className="achievement-card achievement-card-github">
                  <div className="achievement-image-wrapper">
                    <OptimizedImage src="/코드스테이츠.JPG" alt="코드스테이츠 수료증" className="achievement-image" />
                  </div>
                  <div className="achievement-label">6개월 과정 교육 수료</div>
                  <div className="achievement-name">코드스테이츠 프론트엔드</div>
                  <a 
                    href="https://github.com/yolodion/seb41_main_026"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-github-view"
                  >
                   팀 프로젝트 보기
                  </a>
                </div>
                <div className="achievement-card">
                  <div className="achievement-image-wrapper">
                    <OptimizedImage src="/웅진씽크빅.jpg" alt="웅진씽크빅 & 스나이퍼 팩토리 수료증" className="achievement-image" />
                  </div>
                  <div className="achievement-label">디자이너 인턴십 수료</div>
                  <div className="achievement-name">웅진씽크빅 & 스나이퍼 팩토리</div>
                </div>
              </div>
            </div>
            
            <div className="recruitment-footer">
              <p className="recruitment-quote">"재밌게 진심을 담은 가치를 함께 만들어가요"</p>
              <div className="recruitment-buttons">
                <a href="/1995_김동현 이력서.pdf" target="_blank" rel="noopener noreferrer" className="btn-resume">
                  이력서 보기
                </a>
                <a href="mailto:ehdgus5338@gmail.com" className="btn-recruitment">
                  채용 제안하기
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Transition Section */}
        <section className="transition-section">
          <div className="transition-content">
            <div className="transition-clovers">
              <div className="transition-clover clover-1">🍀</div>
              <div className="transition-clover clover-2">🍀</div>
              <div className="transition-clover clover-3">🍀</div>
              <div className="transition-clover clover-4">🍀</div>
              <div className="transition-clover clover-5">🍀</div>
              <div className="transition-clover clover-6">🍀</div>
            </div>
            <p className="transition-text">좋아하는걸 하며, 느긋하고 즐겁게</p>
          </div>
        </section>

        {/* Musician Activity Section */}
        <section className="musician-activity" id="music">
          <div className="section-content">
            <h2 className="section-title">음악 활동</h2>
            
            {/* 음악하는 여행가 프로필 */}
            <div className="profile-card" style={{marginBottom: '4rem', maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto'}}>
              <div className="profile-image-circle musician">
                <OptimizedImage src="/img/10.jpeg" alt="음악하는 여행가" className="profile-img" priority={true} />
              </div>
              <h3 className="profile-role">음악하는 여행가</h3>
              <div className="youtube-link" style={{marginTop: '0.2rem'}}>
                <FaYoutube className="youtube-icon" />
                <a 
                  href="https://www.youtube.com/@happy_dion"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="youtube-text"
                >
                  유튜브 보러가기
                </a>
              </div>
            </div>
            
            {/* 음악 유튜버, 디온 섹션 */}
            <YouTubeVideoSection
              title=""
              subtitle="음악 유튜버, 디온"
              filterKeyword="여행지"
              includeKeyword={false}
            />

            {/* 음악하는 여행가, 디온 섹션 */}
            <YouTubeVideoSection
              title=""
              subtitle="음악하는 여행가, 디온"
              filterKeyword="여행지"
              includeKeyword={true}
            />
          </div>
        </section>

              {/* 음악적인 실력이 늘어서 정말 하고 싶을때 섹션을 열면 좋을듯 */}
        {/* Band Support Section */}
        <section className="band-support" id="band">
          <div className="section-content">
            <h3 className="subsection-title">✨ 밴드 팀원 제안</h3>
            <div className="band-support-container">
              <div className="band-support-images">
                <div className="band-support-image">
                  <OptimizedImage src="/img/13.jpeg" alt="디온 바이올린 연주" className="band-image" />
                </div>
                <div className="band-support-image">
                  <OptimizedImage src="/img/바이올린1.jpeg" alt="디온 바이올린 연주 2" className="band-image" />
                </div>
              </div>
              <div className="band-support-content">
                <div className="band-support-info">
                  <h4 className="band-name">김동현(Dion, 만 30세)</h4>
                  <div className="band-details">
                    <p className="band-detail-item">
                      <span className="band-detail-label">메인:</span>
                      <span className="band-detail-value">바이올린</span>
                    </p>
                    <p className="band-detail-item">
                      <span className="band-detail-label">서브:</span>
                      <span className="band-detail-value">보컬 / 랩 / 자작곡 / 기타</span>
                    </p>
                    <p className="band-detail-item">
                      <span className="band-detail-label">바이올린 경력:</span>
                      <span className="band-detail-value">1년 5개월 (25년 11월 기준)</span>
                    </p>
                  </div>
                  <a 
                    href="mailto:ehdgus5338@gmail.com" 
                    className="btn-band-join"
                  >
                    밴드 팀원 참여 제안하기
                  </a>
                </div>
                <div className="band-support-text">
                  <p className="band-text-item">
                    저는 2024년 여름에 바이올린을 처음 접했지만, 음악이 점점 더 좋아져 꾸준히 연습하고 있습니다.
                  </p>
                  <p className="band-text-item">
                    밴드 루시, 헨리님, 탁보늬님 등 다양한 음악인들이 들려준 좋은 음악과 진심 어린 모습이 깊은 울림으로 다가와 저도 자연스럽게 바이올린과 밴드 음악에 관심을 가지게 되었습니다.
                  </p>
                  <p className="band-text-item">
                    서툴고 부족한 부분이 많지만, 좋은 분들과 함께 취미 / 직장인 밴드에서 소리를 맞추며 함께 음악을 즐기고 싶네요.
                  </p>
                
                  <p className="band-text-item">
                    같이 연주하며 서로의 이야기를 음악으로 나누고, 평범하고 여유로운 일상속에서 함께 기분 좋은 순간들을 쌓아가고 싶습니다. 감사합니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Exercise Activity Section */}
        <section className="exercise-activity" id="exercise">
          <div className="section-content">
            <h2 className="section-title">운동 활동</h2>
            <div className="exercise-content">
              <div className="exercise-images">
                <div className="exercise-image-item exercise-image-special">
                  <OptimizedImage src="/img/특급전사.jpeg" alt="특급전사" priority={true} />
                  <div className="exercise-image-badge">특급전사</div>
                </div>
                <div className="exercise-image-item">
                  <OptimizedImage src="/img/운동1.jpeg" alt="헬스" />
                  <div className="exercise-image-badge">헬스</div>
                </div>
                <div className="exercise-image-item">
                  <OptimizedImage src="/img/운동2.jpeg" alt="강철부대 체험" />
                  <div className="exercise-image-badge">강철부대 체험</div>
                </div>
                <div className="exercise-image-item">
                  <OptimizedImage src="/img/운동3.jpeg" alt="풋살" />
                  <div className="exercise-image-badge">풋살</div>
                </div>
                <div className="exercise-image-item">
                  <OptimizedImage src="/img/운동4.jpeg" alt="홈트" />
                  <div className="exercise-image-badge">홈트</div>
                </div>
                <div className="exercise-image-item">
                  <OptimizedImage src="/img/운동5.jpeg" alt="헬스" />
                  <div className="exercise-image-badge">헬스</div>
                </div>
                <div className="exercise-image-item">
                  <OptimizedImage src="/img/운동6.jpeg" alt="클라이밍" />
                  <div className="exercise-image-badge">클라이밍</div>
                </div>
                <div className="exercise-image-item">
                  <OptimizedImage src="/img/운동7.jpeg" alt="운런닝" />
                  <div className="exercise-image-badge">런닝</div>
                </div>
              </div>
              <div className="exercise-letter">
                <div className="letter-content">
                  <p className="letter-text">
                    어릴 때부터 꾸준히 다양한 운동을 해왔습니다. 학창시절에는 친구들과 풋살, 배드민턴을 하는 시간을 정말 좋아해서 몇년간 꾸준히 해왔던 기억이 있네요. 군대에서는 헬스와 풋살을 자주하면서 멋진 몸도 만들어보고, 꾸준한 노력을 통해 특급전사도 되어 뿌듯했던 경험이 있네요. 최근인 2026년 초에는 바디프로필을 찍었는데, 그냥 평소처럼 운동을 하다가 프로필 사진을 찍고 온것 같네요. 막 거창할것 없이 평소처럼 맛있는것 먹으면서 했고, 미래의 나에게 선물할 수 있는 추억이 하나 더 생긴것 같아서 만족스러운것 같습니다🙂 운동은 건강뿐 아니라 활력을 주고, 스트레스 해소 및 컨디션 회복에도 좋은 영향을 주는것 같습니다. 혼자서도 좋지만, 함께 땀 흘리고 즐기면서 운동하는것도 참 좋은것 같아요. 뭐든 적절히 운동하며 건강한 삶을 만들어 나가면 좋을것 같다는 생각이 드네요. 모두 건강하시고, 화이팅입니다!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Travel Activity Section */}
        <section className="travel-activity" id="travel">
          <div className="section-content">
            <h2 className="section-title">여행 활동</h2>
            <div className="travel-content">
              <div className="travel-images">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66].map((num) => {
                  const ext = num === 15 ? 'png' : (num === 40 || num === 42) ? 'webp' : 'jpeg';
                  return (
                    <div key={num} className="travel-image-item">
                      <OptimizedImage src={`/img/t${num}.${ext}`} alt={`여행 사진 ${num}`} />
                    </div>
                  );
                })}
              </div>
              <div className="travel-message">
                <div className="message-content">
                  <p className="message-text">
                    저는 낭만을 좋아하는, 자유로운 여행가의 성향을 가진 것 같아요. 여행은 늘 저를 설레게 하고, 새로운 마음가짐으로 환기시켜주는 가장 좋아하는 취미이자 삶의 원동력이 되어주는것 같아요. 앞으로도 다양한 곳을 여행하며 좋아하는 사람들과 즐거운 추억을 계속 쌓아가고 싶습니다. 모두 건강하고, 행복하세요😊✈️
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Bucket List Section */}
        {/* <section className="bucket-list-section" id="bucketlist">
          <div className="section-content">
            <BucketList />
          </div>
        </section> */}

        {/* Guestbook Section */}
        
        <section className="guestbook-section" id="guestbook">
          <div className="section-content">
            <h2 className="section-title">인연 방명록</h2>
            <div className="guestbook-container">
              <div className="guestbook-image-wrapper">
                <OptimizedImage 
                  src="/img/아이유.png" 
                  alt="아이유" 
                  className="guestbook-image"
                  priority={true}
                />
              </div>
              <div className="guestbook-content">
                <div className="guestbook-text">
                  <p className="guestbook-intro">
                    안녕하세요. 인연 방명록을 통해 소소한 이야기들을 나누고 싶네요😃

                  </p>
                  <p>
                    저의 이상형은 바로 연예인 아이유님입니다.<br/>저는 아이유님처럼 귀엽고 사랑스러운 분위기와 부드러운 성격을 가진 분을 좋아해요.<br/> 아이유님이 들려주는 음악과 공손하고, 진심 어린 모습이 저에게 좋은 울림으로 다가와서, 자연스럽게 아이유님과 비슷한 분위기와 성향을 가진 분에게 호감을 느끼게 되는것 같아요.
                  </p>
                  <p>
                    하지만 이상형은 이상형일 뿐, 결국엔 가치관이나 성향이 잘 맞고, 좋아하게 되는 연인이 제 이상형이 되는것 같습니다.
                  </p>
                  <p>
                    제가 생각하는 인생의 가장 큰 행복과 행운이 무엇이냐고 묻는다면,<br/>사랑하는 한 사람과 일상 속 소소한 행복을 함께 나누며 평범하게 살아가는 것.<br/>그게 제가 바라는 &lt;클로버리&gt; 속의 행운이라고 말할 수 있을것 같아요.
                  </p>
                  <p>
                    이 공간을 만든 이유도 단순해요. 아무것도 하지 않으면, 아무 일도 일어나지 않을때가 많으니까요.<br/> 저는 사랑에 진심이고, 누군가 이어주지 않는다면 제 스스로 작은 노력을 해보고 싶었던것 같아요.<br/> 물론, 이런 공간을 만들었다고 해서 연락이 올거라는 기대는 크지 않아요.<br/>그치만 아주 작은 용기와 우연이 만나 인연이 된다면, 그것도 정말 멋진 일일것 같네요☺️
                  </p>
                  <p className="guestbook-closing">
                    예전 싸이월드 방명록에 가볍게 흔적을 남기던 그때처럼,<br />
                    생각나신다면 편하게 인사 남겨주셔도 좋아요.<br />꼭 연인 사이가 아니어도 괜찮아요. 편한 친구나 인연이 될 수 있으니까요🍀<br /><br />그렇게 이야기를 나누다 좋은 인연으로 이어진다면, 정말 기쁜일이 될것 같네요.<br /> 긴 글 읽어주셔서 감사하고, 오늘도 평온하고 행복한 하루 보내시길 바랍니다 :)
                  </p>
                </div>
                <div className="guestbook-form">
                  <div className="guestbook-form-title">
                    <span className="form-title-icon">✉️</span>
                    <span>방명록 남기기</span>
                  </div>
                  <div className="guestbook-form-content">
                    <div className="form-group">
                      <textarea
                        id="guest-message"
                        className="form-textarea"
                        placeholder="가볍게 인사 한마디 남겨주세요 😊"
                        value={guestMessage}
                        onChange={(e) => setGuestMessage(e.target.value)}
                        rows={6}
                      />
                    </div>
                    <button
                      className={`btn-guestbook-send ${guestMessage.trim().length > 0 ? 'active' : ''}`}
                      onClick={() => {
                        if (guestMessage.trim().length > 0) {
                          const subject = encodeURIComponent('안녕하세요😊');
                          const body = encodeURIComponent(guestMessage);
                          window.location.href = `mailto:ehdgus5338@gmail.com?subject=${subject}&body=${body}`;
                        }
                      }}
                      disabled={guestMessage.trim().length === 0}
                    >
                      <SiGmail className="btn-icon" />
                      메시지 전송하기
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
       

        {/* Slogan Section */}
        <section className="slogan-section" id="contact">
          <div className="section-content">
            <h2 className="section-title">슬로건</h2>
            <div className="slogan-box">
              <p className="slogan-text">
                좋아하는걸 하며, 느긋하고 즐겁게 살아요. 그러다 좋은 일이 생기면, 행운이죠 🍀
              </p>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <p className="footer-text">© 2025 Cloverly. All rights reserved.</p>
        <div className="footer-contacts">
          <a href="https://www.instagram.com/happy__dion" target="_blank" rel="noopener noreferrer" className="footer-contact-item">
            <FaInstagram className="footer-icon" />
            <span>happy__dion</span>
          </a>
          <a href="mailto:ehdgus5338@gmail.com" className="footer-contact-item">
            <SiGmail className="footer-icon" />
            <span>ehdgus5338@gmail.com</span>
          </a>
        </div>
      </footer>

      {/* 비디오 모달 */}
      {showVideoModal && (
        <div className="video-modal-overlay" onClick={closeVideoModal}>
          <div className="video-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="video-modal-close" onClick={closeVideoModal}>
              ✕
            </button>
            <div className="video-modal-content">
              <video
                src="/tripic.mp4"
                controls
                controlsList="nodownload noplaybackrate"
                disablePictureInPicture
                className="video-modal-player"
                onContextMenu={(e) => {
                  e.preventDefault();
                  return false;
                }}
                onDragStart={(e) => {
                  e.preventDefault();
                  return false;
                }}
              >
                브라우저가 비디오 태그를 지원하지 않습니다.
              </video>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default App;

